import { shadow } from '@coverflex-tech/hypernova-design-tokens';

export const flatShadows = (() => {
  const shadowTypes = Object.keys(shadow) as (keyof typeof shadow)[];
  const shadowVars: Record<string, string> = {};
  shadowTypes.forEach((type) => {
    return Object.entries(shadow[type]).forEach(([key, value]) => {
      shadowVars[`${type}-${key}`] = replaceRemWithPx(value);
    });
  });
  return shadowVars;
})();

function replaceRemWithPx(value: string) {
  return value.replace(/(\d*\.?\d+)rem/g, (match, remValue) => {
    const pxValue = parseFloat(remValue) * 10;
    return `${pxValue}px`;
  });
}
